<template>
  <form :class="{'nx-active' :active}"
        :data-vv-scope="scope"
        :id="'scope-' + scope"
        class="nx-form">
    <h2
        class="nx-form-legend"
        v-html="$t('message.form.scopes.' + scope)"
        v-if="scope"
    ></h2>
    <div class="nx-form-fieldset">

      <nx-form-text
          name="signaturePlace"
          :label="$t('message.form.fields.signaturePlace')"
          :value="draft.signaturePlace"
          validation="alpha_spaces"
          :disabled="disabled"
      ></nx-form-text>

    </div>
  </form>
</template>

<script>
import FormScope from '@/modules/form/FormScope';

export default {
  name: 'nx-form-content-place',
  extends: FormScope,
};
</script>
